import EmailView from "@/features/email-viewer/components/EmailView"
import {useThreadDrawer} from "../ThreadDrawerContext"

export const ThreadDrawer: React.FC = () => {
  const {selectedThread, showThread, hideThread} = useThreadDrawer()

  const handleSetSelectedThread = (threadId: string | null) => {
    if (threadId) {
      showThread(threadId)
    } else {
      hideThread()
    }
  }

  return (
    <EmailView
      selectedThread={selectedThread || ""}
      setSelectedThread={handleSetSelectedThread}
    />
  )
}
